<app-wizard-bar-nav></app-wizard-bar-nav>
<div class="step-container">

  <div>
    <h3>Customer Details | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>

    <h3 *ngIf="isQuickSubmission">Hello, Quick Submit!</h3>

    <form [formGroup]="frmCompanyDetails">

      <h4 *ngIf="!this.userIdentity?.isBroker">Quote on Behalf of a Brokerage</h4>
      <section *ngIf="!this.userIdentity?.isBroker" class="field-group">

        <div class="field-holder">
          <mat-form-field appearance="standard">
            <mat-label>Brokerage</mat-label>
            <mat-select formControlName="brokerage">
              <mat-option value="">-- Please Select --</mat-option>
              <mat-option *ngFor="let assignedBrokerage of assignedBrokerages" [value]="assignedBrokerage.supplierBrokerageId" class="fit-content">
                {{assignedBrokerage.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </section>

      <h4 *ngIf="!this.userIdentity?.isBroker">Associated Internal Sales Agent</h4>
      <section *ngIf="!this.userIdentity?.isBroker" clas="field-group">
        <div class="field-holder">
          <mat-form-field apperance="standard">
            <mat-label>Internal Sales Agent</mat-label>
            <mat-select formControlName="broker">
              <mat-option value="">-- Please Select --</mat-option>
              <mat-option *ngFor="let assignedUser of assignedSupplierUsers" [value]="assignedUser.supplierAgentCode">
                {{assignedUser.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      <app-customer-details formControlName="customerDetails"
                            [customerDetails]="companyDetails"
                            [showValidation]="showValidation"
                            [dunsLookupEnabled]="dunsEnabled"
                            (propagateAddressFound)="storeUtilityInformation($event)"></app-customer-details>

      <div *ngIf="!(isSupplierManagerManualEntry() | async)">
        <h4>Letter of Authority <em id="optional">(Optional)</em></h4>
        <section class="loaUpload">
          <span *ngIf="frmCompanyDetails.disabled && files?.length === 0">No LOA provided</span>
          <app-upload [waitForConfirmationFunc]="resolveWaitForUploadConfirmation"
                      (after-closed)="onCompleteUpload($event)"
                      [document-type]="'LoaDocument'"
                      [upload-description]="'Drag and drop your LOA here'"
                      [disabled]="frmCompanyDetails.disabled"></app-upload>

          <ul class="file-list">
            <li *ngFor="let file of files">
              <div class="delete-file">
                <a class="download-link" appDownloadLink [file]="file">{{ file.fileName }}</a>
                <app-delete-file [file]="file"
                                 [quoteRequestId]="quoteRequestId"
                                 (after-delete)="onDeleteUpload($event)"
                                 [disabled]="frmCompanyDetails.disabled"
                                 [changeInvalidatesQuoteRequest]="this.isQuoteRequestInvalidated()">
                </app-delete-file>
              </div>
            </li>
          </ul>
        </section>
      </div>

      <app-credit-check-light></app-credit-check-light>
      <h4>Supply Details</h4>

        <div class="field-holder w2" style="margin-bottom: 10px;">
          <mat-radio-group aria-label="Select an option" name="commodity" formControlName="commodity" (change)="this.commodityChanged($event)">
            <mat-radio-button value="Electricity" style="margin-right: 10px" [disabled]="!this.isElectricEnabled" [checked]="this.isElectricChecked">
              <img [src]="'/assets/icons/icon-electricity.svg'" style="height: 20px; padding-top: 5px; padding-right: 10px;" />Electricity
            </mat-radio-button>
            <mat-radio-button value="Gas" [disabled]="!this.isGasEnabled" [checked]="this.isGasChecked">
              <img [src]="'/assets/icons/icon-gas.svg'" style="height: 20px; padding-top: 5px; padding-right: 10px;" />Gas
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <h4>Contract Details</h4>
        <mat-radio-group formControlName="saleType" aria-label="Select an option">
          <mat-radio-button checked value="Acquisition" style="margin-right: 10px">Acquisition</mat-radio-button>
          <mat-radio-button value="Renewal">Renewal</mat-radio-button>
        </mat-radio-group>

      <section class="field-group">
        <div class="field-holder w2">
          <mat-form-field appearance="standard" hideRequiredMarker="true">
            <mat-label>Product Type</mat-label>
            <mat-select formControlName="productType" required (selectionChange)="productSelectionChanged($event?.value)">
              <mat-option value="">-- Please Select --</mat-option>
              <mat-option *ngFor="let productType of ((productTypes$ | async)?.length < 1 ? [{productType: 'Fixed'}] : productTypes$ | async)" [value]="productType.productType">
                {{productType.productType}}
              </mat-option>
            </mat-select>
            <mat-error> Please select a Product Type. </mat-error>
          </mat-form-field>
        </div>
      </section>

      <section class="field-group">
        <div class="field-holder contract-lengths" *ngIf="this.showContractLengths === true">
          <label>Contract Length (months)</label>
          <app-contract-lengths formControlName="contractLengths"
                                [FilterMode]="false"
                                [showAllButton]="true"
                                [showPlusButton]="isDynamic$ | async"
                                [contractLenghtsToShow]="defaultContractLengthButtonsToShow"
                                (notifyAllChanged)="allContractLengthsSelected($event)">
          </app-contract-lengths>
          <!-- This validation error issue needs to be investigated -->
          <mat-error *ngIf="contractLengths?.invalid && (contractLengths.dirty || contractLengths.touched)">
            Please select at least one Contract Length
          </mat-error>
          <!-- <mat-error *ngIf="contactLengthClickEvent?.maxReached"> You can select up to 5 Contract Lengths </mat-error> -->
        </div>
      </section>
      <!-- sweet spot checkbox won't be shown when contract lengths are not selectable -->
      <section *ngIf="this.showContractLengths === true">
        <br />
        <mat-checkbox id="sweetSpotCheckbox" color="primary" formControlName="sweetSpotCheckbox" (change)="sweetSpotCheckboxChanged($event)">
          <span id="checkboxText">Include Sweet Spot for the full range</span>
        </mat-checkbox>
      </section>

      <app-billing-input></app-billing-input>

      <h4>Notes</h4>
      <section class="field-group">
        <div class="field-holder w6">
          <textarea id="quoteConfigNotes"
                    matInput
                    formControlName="notes"
                    rows="5"
                    placeholder="Please add your additional pricing details here"></textarea>

          <mat-error *ngIf="notes?.invalid && (notes?.dirty || notes?.touched)"> Notes cannot exceed 255 characters </mat-error>
        </div>
      </section>

    </form>
  </div>




  <app-wizard-step-nav-buttons [hideBack]="true" (nextClicked)="next()"></app-wizard-step-nav-buttons>
  <!-- <pre [ngStyle]="{ 'background-color': this.frmCompanyDetails?.valid ? 'palegreen' : 'red' }" style="position: fixed; top: 100px; right: 400px; padding: 10px;">CustomerDetails: {{this.frmCompanyDetails?.getRawValue() | json}}</pre> -->
</div>


